import { render, staticRenderFns } from "./TutorialEndEmoji.vue?vue&type=template&id=bc40cb4a&scoped=true"
import script from "./TutorialEndEmoji.vue?vue&type=script&lang=ts"
export * from "./TutorialEndEmoji.vue?vue&type=script&lang=ts"
import style0 from "./TutorialEndEmoji.vue?vue&type=style&index=0&id=bc40cb4a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc40cb4a",
  null
  
)

export default component.exports